// src/utils/AlpineCartRefresher.js

/**
 * Refreshes the cart in Alpine.js. Useful when using the Quick Add to Cart feature.
 */
const AlpineCartRefresher = {
    fetchCart() {
        return fetch('/cart.js')
            .then(res => {
                if (!res.ok) throw new Error('Cart fetch failed');
                return res.json();
            });
    },

    refreshAlpineCart() {
        const Alpine = window.Alpine;
        if (!Alpine || !Alpine.store || !Alpine.store('cart')) {
            console.warn('Alpine or cart store not initialized yet');
            return;
        }

        // flip on your loading overlay
        Alpine.store('cart').loading = true;

        this.fetchCart()
            .then(cartData => {
                // overwrite the store’s cart data
                Alpine.store('cart').data = cartData;
            })
            .catch(err => {
                console.error('Error refreshing cart:', err);
            })
            .finally(() => {
                // flip it back off
                Alpine.store('cart').loading = false;
            });
    }
};

export default AlpineCartRefresher;
export { AlpineCartRefresher };